import React from 'react';

const SVGIcon = ({iconName, color = "#000", width = 80, height = 80}) => {

    return (
        <svg
            width={`${width}pt`}
            height={`${height}pt`}
            fill={color}
            viewBox="0 0 128 128"
        >
           <use href={iconName}/>
        </svg>
    );
};

export default SVGIcon;